import { Flame, Plus } from 'lucide-react';
import { Button } from '@/components/Button';
import { EmptyState } from '@/components/EmptyState';

export function HotendsPage() {
  return (
    <div className="p-4">
      {/* Page header */}
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-lg font-semibold text-foreground">Hotends</h1>
          <p className="text-sm text-foreground-muted">Manage your hotend inventory</p>
        </div>
        <Button size="sm" leftIcon={<Plus className="h-4 w-4" />}>
          Add Hotend
        </Button>
      </div>

      {/* Empty state */}
      <div className="rounded border border-border bg-background-subtle p-4">
        <EmptyState
          icon={<Flame className="h-10 w-10" />}
          title="No hotends yet"
          description="Track your hotend inventory including types, temperatures, and compatibility."
          actionLabel="Add Hotend"
          onAction={() => {
            // TODO: Open add hotend modal
          }}
        />
      </div>
    </div>
  );
}
